import actions from "./actions";

const {
  SET_DATA_SEMINUEVOS,
  GET_DATA_BEGIN_SEMINUEVOS,
  GET_DATA_FINISH_SEMINUEVOS,
} = actions;

const initialState = {
  seminuevos: [],
  loading: false,
  totalItems: 0,
  currentPage: 1,
};

const seminuevosReducer = (state = initialState, action: any) => {
  const { type, data } = action;
  switch (type) {
    case GET_DATA_BEGIN_SEMINUEVOS:
      return { ...state, loading: true };
    case SET_DATA_SEMINUEVOS:
      return {
        ...state,
        seminuevos: Array.isArray(data?.list) ? data.list : [],
        totalItems: data?.totalItems || 0,
        currentPage: data?.currentPage || 1,
        loading: false,
      };
    case GET_DATA_FINISH_SEMINUEVOS:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export { seminuevosReducer };
